<template>
  <div class="container">
    <div class="header-logos">
      <a class="header-logo-uhh" href="https://www.uni-hamburg.de">
        <img class="header-logo-image" src="../../assets/images/logo/uni-hamburg-logo.svg" />
      </a>
      <a class="header-logo-linguasnapp" href="https://www.linguasnapp.uni-hamburg.de">
        <img class="header-logo-image" src="../../assets/images/logo/linguasnapp-logo.png" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
    name: 'HeaderLogos',
};
</script>

<style scoped>
.header-logos {
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
}

.header-logo-uhh {
  margin-top: 38px;
  margin-bottom: 43px;
}

.header-logo-image {
  width: 270px;
  user-select: none;
}

.header-logo-linguasnapp {
  margin-top: 38px;
  margin-bottom: 43px;
}

@media (max-width: 580px) {
  .header-logo-image {
    width: 185px;
  }
}

@media (max-width: 420px) {
  .header-logo-image {
    width: 135px;
  }
}
</style>
